import React, { useState, useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';

const ExpenseReimbursedAmount = (props) => {
    const {
        index,
        expense,
        mode,
        isPendingSubmission,
        isPosted,
        isViewOnly,
        enableEditByCorrection,
    } = props;
    const { control, errors } = useFormContext();
    const [required, setRequired] = useState({ required: false });
    useEffect(() => {
        setRequired({ required: expense?.status === ExpenseStatusValuesEnum.Approved });
    }, [expense?.status]);

    return (
        <Grid2 item size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].reimbursedAmount`}
                defaultValue={expense.reimbursedAmount !== null ? expense.reimbursedAmount : ''}
                rules={{
                    required: required.required
                        ? 'Reimbursed amount is required for approval'
                        : false,
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        {...required}
                        placeholder=""
                        id={`expense-reimbursed-amount${index}`}
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        label="Reimbursed amount"
                        endAdornment={
                            <AmountCurrencyInputAdornment
                                disabled
                                index={index}
                                currencyType="USD"
                            />
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.reimbursedAmount)}
                        disabled={
                            isViewOnly ||
                            (isPendingSubmission && !enableEditByCorrection) ||
                            (isPosted && isViewOnly)
                        }
                        helperText={errors.expenseEntries?.[index]?.reimbursedAmount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpenseReimbursedAmount;
